"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _useTheme = _interopRequireDefault(require("../useTheme"));

var _Checkbox = _interopRequireDefault(require("../checkbox/Checkbox"));

var _Icons = _interopRequireDefault(require("./Icons"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Option = function Option(_ref) {
  var id = _ref.id,
      option = _ref.option,
      _onClick = _ref.onClick,
      multiple = _ref.multiple,
      visualFocused = _ref.visualFocused,
      _ref$isGroupedOption = _ref.isGroupedOption,
      isGroupedOption = _ref$isGroupedOption === void 0 ? false : _ref$isGroupedOption,
      isLastOption = _ref.isLastOption,
      isSelected = _ref.isSelected;
  var colorsTheme = (0, _useTheme["default"])();
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: colorsTheme.select
  }, /*#__PURE__*/_react["default"].createElement(OptionItem, {
    id: id,
    onClick: function onClick() {
      _onClick(option);
    },
    visualFocused: visualFocused,
    selected: isSelected,
    role: "option",
    "aria-selected": isSelected
  }, /*#__PURE__*/_react["default"].createElement(StyledOption, {
    visualFocused: visualFocused,
    selected: isSelected,
    last: isLastOption,
    grouped: isGroupedOption,
    multiple: multiple
  }, multiple && /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
    checked: isSelected,
    tabIndex: -1
  }), option.icon && /*#__PURE__*/_react["default"].createElement(OptionIcon, {
    grouped: isGroupedOption,
    multiple: multiple,
    role: !(typeof option.icon === "string") ? "img" : undefined
  }, typeof option.icon === "string" ? /*#__PURE__*/_react["default"].createElement(OptionIconImg, {
    src: option.icon
  }) : option.icon), /*#__PURE__*/_react["default"].createElement(OptionContent, {
    grouped: isGroupedOption,
    hasIcon: option.icon ? true : false,
    multiple: multiple
  }, /*#__PURE__*/_react["default"].createElement(OptionLabel, null, option.label), !multiple && isSelected && /*#__PURE__*/_react["default"].createElement(OptionSelectedIndicator, null, _Icons["default"].selected)))));
};

var OptionItem = _styledComponents["default"].li(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  padding: 0 0.5rem;\n  box-shadow: inset 0 0 0 2px transparent;\n  ", "\n  ", ";\n  line-height: 1.715em;\n  cursor: pointer;\n\n  &:hover {\n    ", ";\n  }\n  &:active {\n    ", ";\n  }\n"])), function (props) {
  return props.visualFocused && "box-shadow: inset 0 0 0 2px ".concat(props.theme.focusListOptionBorderColor, ";");
}, function (props) {
  return props.selected && "background-color: ".concat(props.theme.selectedListOptionBackgroundColor);
}, function (props) {
  return props.selected ? "background-color: ".concat(props.theme.selectedHoverListOptionBackgroundColor, ";") : "background-color: ".concat(props.theme.unselectedHoverListOptionBackgroundColor, ";");
}, function (props) {
  return props.selected ? "background-color: ".concat(props.theme.selectedActiveListOptionBackgroundColor, ";") : "background-color: ".concat(props.theme.unselectedActiveListOptionBackgroundColor, ";");
});

var StyledOption = _styledComponents["default"].span(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  padding: 0.25rem 0.5rem 0.188rem 0;\n  min-height: 24px;\n  ", "\n  ", ";\n"])), function (props) {
  return props.grouped && props.multiple && "padding-left: 16px;";
}, function (props) {
  return props.last || props.visualFocused || props.selected ? "border-bottom: 1px solid transparent" : "border-bottom: 1px solid ".concat(props.theme.listOptionDividerColor);
});

var OptionIcon = _styledComponents["default"].span(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-wrap: wrap;\n  align-content: center;\n  height: 24px;\n  width: 24px;\n  ", "\n  color: ", ";\n"])), function (props) {
  return props.grouped && !props.multiple ? "padding-left: 16px;" : "padding-left: 8px;";
}, function (props) {
  return props.theme.listOptionIconColor;
});

var OptionContent = _styledComponents["default"].span(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  overflow: hidden;\n  ", "\n"])), function (props) {
  return props.grouped && !props.multiple && !props.hasIcon ? "padding-left: 16px;" : "padding-left: 8px;";
});

var OptionIconImg = _styledComponents["default"].img(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  width: 16px;\n  height: 16px;\n"])));

var OptionLabel = _styledComponents["default"].span(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"])));

var OptionSelectedIndicator = _styledComponents["default"].span(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  height: 16px;\n  width: 16px;\n  margin-left: 4px;\n  color: ", ";\n"])), function (props) {
  return props.theme.selectedListOptionIconColor;
});

var _default = /*#__PURE__*/_react["default"].memo(Option);

exports["default"] = _default;